<template>
  <div class="pt-150">
    <div class="hero">
      <div class="hero-body">
        <div class="title"> hellooooo</div>

      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: "home",
  components: {
  },
  data: function () {
    return {
    };
  },
  methods: {
  }
};
</script>
<style>
</style>
